import SessionService from './services/SessionService'

export const isAdmin = () => {
    try {
        let partnerLogged = SessionService.getPartnerLogged(false) // for this check, control only the real partner logged and not if is masqueraded 
        return partnerLogged && partnerLogged != null && partnerLogged.partnerId === 'p-admin'
    } catch (e) {
        //
    }
    return false
}
